import { render, staticRenderFns } from "./TakipAltTipAlanlarList.vue?vue&type=template&id=384933a4&scoped=true"
import script from "./TakipAltTipAlanlarList.vue?vue&type=script&lang=ts"
export * from "./TakipAltTipAlanlarList.vue?vue&type=script&lang=ts"
import style0 from "./TakipAltTipAlanlarList.vue?vue&type=style&index=0&id=384933a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384933a4",
  null
  
)

export default component.exports